export default __webpack_public_path__ + "static/media/space_object_01.f4d9d625.svg";